import datapoints from '../datapoints';
import { logUsage } from 'owa-analytics';
import { getUserConfiguration } from 'owa-session-store';

export function logCurrentTimeZoneQuick() {
    let { UserOptions } = getUserConfiguration();
    if (UserOptions.TimeZone != null) {
        const customData = datapoints.CurrentTimeZoneQuick.datapoint.customData(
            UserOptions.TimeZone
        );
        logUsage(datapoints.CurrentTimeZoneQuick.datapoint.name, customData);
    }
}

export function logDateFormatQuick() {
    let { UserOptions } = getUserConfiguration();
    if (UserOptions.DateFormat != null) {
        const customData = datapoints.DateFormatQuick.datapoint.customData(UserOptions.DateFormat);
        logUsage(datapoints.DateFormatQuick.datapoint.name, customData);
    }
}

export function logTimeFormatQuick() {
    let { UserOptions } = getUserConfiguration();
    if (UserOptions.TimeFormat != null) {
        const customData = datapoints.TimeFormatQuick.datapoint.customData(UserOptions.TimeFormat);
        logUsage(datapoints.TimeFormatQuick.datapoint.name, customData);
    }
}
